import React, { useEffect } from "react"
import PropTypes from "prop-types"
import shortid from "shortid"
import { Link } from "gatsby"
import IconButton from "@material-ui/core/IconButton"
import { HiOutlineDotsVertical, HiOutlineDotsHorizontal } from "react-icons/hi"

import { LocaleContext } from "../contexts/LocaleContext"

import Breadcrumbs from "./Breadcrumbs"

const SidebarMenu = ({ items, current, breadcrumbs }) => {
  const lang = React.useContext(LocaleContext)
  const i18n = lang.i18n[lang.locale]

  const [showMenu, setShowMenu] = React.useState(() => {
    const showMenuStorage =
      typeof window !== "undefined" && window.localStorage.getItem("showMenu")
    return showMenuStorage === "true" || !showMenuStorage
  })

  const toggleShowMenu = event => {
    setShowMenu(!showMenu)
  }

  useEffect(() => {
    localStorage.setItem("showMenu", showMenu)
  }, [showMenu])

  const getLink = item =>
    `${i18n.path}/${item.data.parent_page.document.uid}/${item.uid}/`

  return (
    <nav id="sidebar-nav">
      <div className={`button-wrapper ${showMenu ? "open" : "closed"}`}>
        <IconButton className="button" onClick={() => toggleShowMenu()}>
          {showMenu && <HiOutlineDotsHorizontal color="#000" size="1.6em" />}
          {!showMenu && <HiOutlineDotsVertical color="#fff" size="1.6em" />}
          &nbsp;categorii
        </IconButton>
      </div>
      {showMenu && (
        <ul>
          {items.map(item => (
            <li key={shortid.generate()}>
              <Link
                to={getLink(item)}
                className={item.uid === current ? "active" : ""}
              >
                {item.data.title.text.toUpperCase()}
              </Link>
            </li>
          ))}
        </ul>
      )}

      {showMenu && <Breadcrumbs breadcrumbs={breadcrumbs} />}
    </nav>
  )
}

export default SidebarMenu

SidebarMenu.propTypes = {
  items: PropTypes.array.isRequired,
  current: PropTypes.string.isRequired,
  breadcrumbs: PropTypes.array.isRequired,
}
